import React from 'react';

import ApplicationLayout from '../layouts/ApplicationLayout';

/*
  Applications routes
*/
import InstallIcons from './InstallIcons';
import Loggedout from './Loggedout';
import Summary from './Summary';
import Documents from './Documents';

import _NeuropsychologistView from './Documents/routes/_NeuropsychologistView';

// TODO: Remove mock route
const AppRouter = () => (
  <ApplicationLayout>
    {window.__ROLE__ === 'NEUROPSYCHOLOGIST' ? (
      <_NeuropsychologistView />
    ) : (
      <React.Fragment>
        <Summary />
        <Documents />
        <InstallIcons />
        <Loggedout />
      </React.Fragment>
    )}
  </ApplicationLayout>
);

export default AppRouter;
